module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/fo-8b4db68d6e0717fe940e8f23f6bedb8a.svg";